import {TranslationObject} from '@colonist/i18n'
import {BaseCardData, CardClickPopupType} from '@colonist/game-card-types'
import {CardEnum, CardTypeEnum, TurnState} from '@colonist/game-states'

export class CardProgressPoliticsCardBack extends BaseCardData {
    cardEnum = CardEnum.ProgressCardPoliticsBack
    cardTypeEnum = CardTypeEnum.ProgressPolitics
    isCardBack = true
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.politics.back.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.politics.back.body'}
    clickPopupType = CardClickPopupType.None
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.politics.back.popupBody'}
    allowableTurnStates = undefined
}

export class CardProgressPoliticsBishop extends BaseCardData {
    cardEnum = CardEnum.ProgressCardPoliticsBishop
    cardTypeEnum = CardTypeEnum.ProgressPolitics
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.politics.bishop.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.politics.bishop.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.politics.bishop.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressPoliticsConstitution extends BaseCardData {
    cardEnum = CardEnum.ProgressCardPoliticsConstitution
    cardTypeEnum = CardTypeEnum.ProgressPolitics
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.politics.constitution.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.politics.constitution.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.politics.constitution.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressPoliticsDeserter extends BaseCardData {
    cardEnum = CardEnum.ProgressCardPoliticsDeserter
    cardTypeEnum = CardTypeEnum.ProgressPolitics
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.politics.deserter.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.politics.deserter.body'}
    clickPopupType = CardClickPopupType.NormalClick
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.politics.deserter.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressPoliticsDiplomat extends BaseCardData {
    cardEnum = CardEnum.ProgressCardPoliticsDiplomat
    cardTypeEnum = CardTypeEnum.ProgressPolitics
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.politics.diplomat.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.politics.diplomat.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.politics.diplomat.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressPoliticsIntrigue extends BaseCardData {
    cardEnum = CardEnum.ProgressCardPoliticsIntrigue
    cardTypeEnum = CardTypeEnum.ProgressPolitics
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.politics.intrigue.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.politics.intrigue.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.politics.intrigue.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressPoliticsSaboteur extends BaseCardData {
    cardEnum = CardEnum.ProgressCardPoliticsSaboteur
    cardTypeEnum = CardTypeEnum.ProgressPolitics
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.politics.saboteur.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.politics.saboteur.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.politics.saboteur.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressPoliticsSpy extends BaseCardData {
    cardEnum = CardEnum.ProgressCardPoliticsSpy
    cardTypeEnum = CardTypeEnum.ProgressPolitics
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.politics.spy.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.politics.spy.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.politics.spy.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressPoliticsWarlord extends BaseCardData {
    cardEnum = CardEnum.ProgressCardPoliticsWarlord
    cardTypeEnum = CardTypeEnum.ProgressPolitics
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.politics.warlord.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.politics.warlord.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.politics.warlord.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}

export class CardProgressPoliticsWedding extends BaseCardData {
    cardEnum = CardEnum.ProgressCardPoliticsWedding
    cardTypeEnum = CardTypeEnum.ProgressPolitics
    isCardBack = false
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.politics.wedding.title'}
    tipBody: TranslationObject = {key: 'strings:game.cards.progress.politics.wedding.body'}
    clickPopupType = CardClickPopupType.ConfirmationPopup
    popupBody: TranslationObject = {key: 'strings:game.cards.progress.politics.wedding.popupBody'}
    allowableTurnStates = [TurnState.Turn]
}
